import { DragEvent, ChangeEvent, useState, useEffect } from 'react';
import '../../styles/DragAndDrop.css';
import { toIcons } from '../../consts/Paths';
import { UseFormRegister } from 'react-hook-form';
import CustomModal from '../modals/CustomModal';

// interface UploadedFile {
//     ordering: number;
//     filename: string;
//     base64: string;
// }

const DragAndDropImages = (props: any) => {
    const [files, setFiles] = useState<any[]>([]);
    const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
    const [popupDetailedImage, setPopupDetailedImage] = useState(false);
    const [detailedImage, setDetailedImage] = useState<any>();

    const handleDrop = async (event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        const newFiles = Array.from(event.dataTransfer.files).filter((file) => file.type.startsWith('image/'));
        await processFiles(newFiles);
    };

    const handleFileSelect = async (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            const newFiles = Array.from(event.target.files).filter((file) => file.type.startsWith('image/'));
            await processFiles(newFiles);
        }
    };

    const handleDragOver = (event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();
    };

    const processFiles = async (newFiles: File[]) => {
        const processedFiles = await Promise.all(
            newFiles.map(async (file) => {
                const base64 = await fileToBase64(file);
                const cleanedBase64String = base64.replace(/^data:image\/jpeg;base64,/, '');

                return {
                    ordering: 0,
                    filename: file.name.replace(/\s/g, ""),
                    base64: base64 || '',
                };
            })
        );

        setFiles((prevFiles) => {
            console.log(prevFiles);
            const updatedFiles = [...prevFiles, ...processedFiles];
            return updatedFiles.map((file, index) => ({ ...file, ordering: index + 1 }));
        });
    };

    const fileToBase64 = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });
    };

    const handleDragStart = (index: number) => {
        setDraggedIndex(index);
    };

    const handleDragEnter = (index: number) => {
        if (draggedIndex !== null && draggedIndex !== index) {
            const reorderedFiles = [...files];
            const [draggedFile] = reorderedFiles.splice(draggedIndex, 1);
            reorderedFiles.splice(index, 0, draggedFile);
            setDraggedIndex(index);
            setFiles(reorderedFiles.map((file, i) => ({ ...file, ordering: i + 1 })));
        }
    };

    const handleDragEnd = () => {
        setDraggedIndex(null);
    };

    const handleDelete = (index: number) => {
        setFiles((prevFiles) => {
            const updatedFiles = prevFiles.filter((_, i) => i !== index);
            return updatedFiles.map((file, i) => ({ ...file, ordering: i + 1 }));
        });
    };

    useEffect(() => {
        props.setValue('images', files);
    }, [props.setValue, files]);

    const sortProductsByOrdering = () => {
        const imagesRemapped =
            (props.images &&
                props.images.length > 0 &&
                props.images.map((item: any) => ({
                    ordering: item.order,
                    filename: item.name,
                    base64: item.base64 || '',
                    url: item.url,
                }))) ||
            [];
        return (imagesRemapped.length > 0 && imagesRemapped.slice().sort((a: any, b: any) => a.ordering - b.ordering)) || [];
    };

    useEffect(() => {
        const orderedFiles = sortProductsByOrdering();
        console.log(orderedFiles);
        setFiles(orderedFiles);
    }, []);

    const closeDetailedImage= ()=>{
        setDetailedImage(null);
        setPopupDetailedImage(false);
    };

    const openDetailedImage = (picture:any) =>{
        setDetailedImage(picture);
        setPopupDetailedImage(true);
    };

    return (
        <div>
                {popupDetailedImage && (
                    <CustomModal setShow={setPopupDetailedImage} title='Dettaglio immagini' ctaTtitle='Chiudi' ctaFunction={closeDetailedImage} description={''}>
                        <div>
                            <img width={768} height={576} src={`${detailedImage.base64 || detailedImage.url}`} />
                        </div>
                    </CustomModal>
                    )}
            <div onDrop={handleDrop} onDragOver={handleDragOver} className='dropBox'>
                <input type='file' multiple accept='image/*' onChange={handleFileSelect} style={{ display: 'none' }} id='fileInput' />
                <label htmlFor='fileInput' style={{ cursor: 'pointer' }}>
                    Trascina e rilascia alcune immagini qui, o fai clic per selezionare le immagini
                </label>
            </div>
            <div style={{ marginTop: '20px' }}>
                {files.length > 0 && (
                    <div>
                        <ul className='imagesList'>
                            {files.map((file, index) => (
                                <ol
                                    key={index}
                                    draggable
                                    onDragStart={() => handleDragStart(index)}
                                    onDragEnter={() => handleDragEnter(index)}
                                    onDragEnd={handleDragEnd}
                                    style={{ border: draggedIndex === index ? '2px solid blue' : 'none', userSelect: 'none' }}
                                >
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: 10,
                                            left: 10,
                                            width: 30,
                                            height: 30,
                                            backgroundColor: '#fff',
                                            borderRadius: 8,
                                        }}
                                    >
                                        
                                        <img
                                            style={{
                                                cursor: 'pointer',
                                                marginLeft: 'auto',
                                                width: 30,
                                                height: 30,
                                            }}
                                            src={`${toIcons}/close.svg`}
                                            onClick={() => handleDelete(index)}
                                        />
                                    </div>
                                    
                                    <img src={`${file.base64 || file.url}`} onClick={()=>openDetailedImage(file)} />
                                    <p>{file.filename}</p>
                                </ol>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DragAndDropImages;
